<template>
    <div class="col-sm-12 nopads">
        <div v-if="!assignmentMode" class="col-sm-12 editor-form">
            <h2 class="editor-header">{{ defectUpdate.id > 0 ? $t('defects.edit') : $t('defects.new') }}</h2>
            <span class="span-title">
                  {{ $t('areas.area') }}
            </span>
                <div class="form-group">
                    <select
                        id="area"
                        class="form-select form-select-sm sm-3"
                        v-model="defectUpdate.area.id"
                        :disabled="!isNew"
                        @change="onAreaChange"
                    >
                        <option v-for="area in areas" :key="area.id" :value="area.id">
                            {{ area.name }}
                        </option>
                    </select>
                </div>

                <span class="span-title">
                  {{ $t('area_defects.equipment') }}
                </span>
                <div class="form-group">
                    <select
                        id="equipment"
                        class="form-select form-select-sm sm-3"
                        v-model="defectUpdate.area_equipment"
                    >
                        <option :value="null">
                            {{ $t('area_defects.select_equipment') }}
                        </option>
                        <option v-for="item in equipment" :key="item.id" :value="item">
                            {{ item.name }}
                        </option>
                    </select>
                </div>

                <span class="span-title">
                    {{ $t('defects.description') }}
                </span>
                <div class="form-group title">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="defectUpdate.description"
                    />
                </div>

                <span class="span-title">
                  {{ $t('defects.status') }}
                </span>
                <div class="form-group nopads">
                    <select
                        id="status"
                        class="form-select form-select-sm sm-3"
                        v-model="defectUpdate.status"
                    >
                        <option v-if="!isNew" :value="2">
                            {{ $t('inspection.options.okay') }}
                        </option>
                        <option :value="resultDefect">
                            {{ $t('inspection.options.defects') }}
                        </option>
                        <option :value="resultBan">
                            {{ $t('inspection.options.ban') }}
                        </option>
                    </select>
                </div>

                <work-assignment-view
                    v-if="!isNew"
                    :id="defect.id"
                    :type="1"
                    :can-edit="true"
                    :can-add="isObserver"
                    @edit-assignment="editAssignment"
                />

                <div class="col-sm-12 my-2 text-end">
                    <button type="button" class="btn btn-danger form-button" @click.stop="$emit('close')">
                        {{ $t('common.cancel') }}
                    </button>
                    <button type="button" class="btn btn-success form-button" :disabled="loading || !validateFields()" @click.stop="submit">
                      {{ $t('common.save') }}
                    </button>
                </div>
            </div>
        <div v-if="!isNew && assignmentMode">
            <Transition name="fade">
                <work-assignment-editor
                    :area-defect="defect"
                    :is-observer="isObserver"
                    :work-assignment="workAssignment"
                    @close="setAssignmentEditorVisibility(false)"
                    @close-and-update="closeAndUpdate"
                />
            </Transition>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {areaHelper as AreaHelper} from '../../mixins/AreaMixin'
import WorkAssignmentEditor from '../../workassignment/WorkAssignmentEditor'
import {workAssignmentHelper} from '../../mixins/WorkAssignmentMixin'
import WorkAssignmentView from '../../workassignment/WorkAssignmentView'
import {inject} from "vue";

export default {
    name: 'AreaDefectEditor',
    components: {WorkAssignmentEditor, WorkAssignmentView},
    mixins: [restApi, AreaHelper, workAssignmentHelper],
    props: {
        defect: {
            type: Object,
            default: null
        },
        isObserver: Boolean
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            areas: [],
            equipment: [],
            loading: false,
            defectUpdate: this.defect,
            isNew: this.defect.id < 1,
            workAssignment: null,
            assignmentMode: false
        }
    },
    mounted: function () {
        if (this.isNew) {
            this.fetchAreas()
        } else {
            this.areas = [this.defectUpdate.area]
            this.fetchEquipment()
        }
    },
    methods: {
        fetchAreas: function () {
            this.loading = true
            this.restFetchParams(this.areaUrl, {no_geom: 1}, this.handleAreas)
        },

        handleAreas: function (response) {
            this.loading = false
            this.areas = response.data
        },

        onAreaChange: function () {
            this.defectUpdate.area_equipment = null
            this.fetchEquipment()
        },

        fetchEquipment: function () {
            if (this.defectUpdate.area.id != null) {
                this.loading = true
                this.restFetchParams(this.areaEquipmentUrl, {area: this.defectUpdate.area.id}, this.handleEquipment)
            }
        },

        handleEquipment: function (response) {
            this.loading = false
            this.equipment = response.data
        },

        checkValues: function (defect) {
            if (defect.status < 1 ||
                !defect.area || defect.area.id < 1) {
                return undefined
            }
            if (this.isNew) {
                defect.fixer = null
                defect.fixed_date = null
            }
            defect.area = {'id': defect.area.id}
            defect.reporter = {'id': defect.reporter.id}
            if (defect.fixer) defect.fixer = {'id': defect.fixer.id}
            if (defect.area_equipment) defect.area_equipment = {'id': defect.area_equipment.id}
            return defect
        },

        submit: function () {
            let json = this.checkValues(this.defectUpdate)
            if (json !== undefined) {
                this.loading = true
                if (this.isNew) {
                    this.restAdd(this.areaDefectUrl, json, this.success, this.fail)
                } else {
                    this.restUpdate(this.areaDefectUrl, json, this.success, this.fail)
                }
            } else {
                this.showAlert(this.$t('defects.missing_fields'))
            }
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },

        validateFields: function () {
            return this.defectUpdate.area.id !== -1 && this.defectUpdate.status !== -1
        },

        setAssignmentEditorVisibility: function (visible) {
            this.assignmentMode = visible
        },

        closeAndUpdate: function (assignment) {
            this.setAssignmentEditorVisibility(false)
            this.workAssignment = assignment
        },

        editAssignment: function (assignment) {
            this.workAssignment = assignment
            this.setAssignmentEditorVisibility(true)
        }
    }

}
</script>
